import { FeaturesResponse } from '../types';
import { getCleanUrl } from './url';
import { makeGetRequest } from './http';
import { NEXUS_API_URL } from '../constants';

export declare const DISABLE_AUDIENCES: boolean;
export declare const DISABLE_FEATURES: boolean;

export const getPagesAndAudiences = async (
  apiKey: string,
  accountId: string,
  publisherId: string,
  loadId: string
) => {
  // TODO: move URL clean to server.
  const url = getCleanUrl();
  const [pagesResponse, audiencesResponse] = await Promise.all([
    makeGetRequest<FeaturesResponse>(
      `${NEXUS_API_URL}/pages?accId=${accountId}&pubId=${publisherId}&url=${encodeURIComponent(
        url
      )}`,
      apiKey,
      loadId
    ),
    // NOTE: we are currently setting purely contextual audiences
    // from the call to /pages
    Promise.resolve({ error: undefined, data: [] }),
    /* 
    makeGetRequest<AudienceDefinition[]>(
      `${NEXUS_API_URL}/audiences`,
      apiKey,
      loadId
    ), 
    */
  ]);

  return {
    pagesResponse: {
      error: pagesResponse.error,
      data: pagesResponse.data,
    },
    audiencesResponse: {
      error: audiencesResponse.error,
      data: audiencesResponse.data,
    },
  };
};

export const logError = async (
  _loadId: string,
  _apiKey: string,
  _error: { name: string; message: string; stack: string },
  _version: string
): Promise<void> => {
  // NOTE: Disable the `error` report in scope of https://github.com/AirGrid/rmap/issues/2739
  // It can be removed after logs and cost analysis.
  // await makePostRequest(
  //   ANALYTICS_ERROR_URL,
  //   JSON.stringify({
  //     version,
  //     name: error.name,
  //     message: error.message,
  //     stack: error.stack,
  //     url: getCleanUrl(),
  //   }),
  //   apiKey,
  //   loadId
  // );
};
